import React, { useEffect, useState } from "react";
import CardProfile from "../../../components/cards/profile/OwnProfile";
import HeroProfile from "../../../components/hero/HeroProfile";
import SidebarProfile from "../../../components/sidebars/SidebarProfile";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import CollectionProfile from "../../../components/cards/profile/CollectionProfile";
import useDocumentTitle from "../../../components/useDocumentTitle";
import { Link, useParams } from "react-router-dom";
import { getUserByAddress } from "../../../hooks/User";
import OwnAssetProfile from "../../../components/cards/profile/OwnProfile";
import CreatedAssetProfile from "../../../components/cards/profile/CreatredAssetProfile";
import { handleApiError, retryApiCall } from '../../../utils/apiUtils';

const OtherProfile = () => {
  useDocumentTitle("Profile ");
  const [user, setUser] = useState({});
  const { walletAddress } = useParams();
  const [selectedTab, setSelectedTab] = useState(0); // Main tabs

  console.log("walletAddress", walletAddress);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        setIsLoading(true);
        const data = await retryApiCall(
          () => getUserByAddress(walletAddress),
          3,
          1000
        );
        if (data.status === 200) {
          setUser(data.user);
        } else {
          throw new Error(data?.message || "Failed to fetch user data");
        }
      } catch (error) {
        handleApiError(error, "Failed to load user profile");
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserData();
  }, [walletAddress]);

  const renderContent = () => {
    switch (selectedTab) {
      case 0:
        return <OwnAssetProfile user={user} address={walletAddress} />;
      case 1:
        return <CreatedAssetProfile user={user} address={walletAddress} />;
      case 2:
        return <CollectionProfile user={user} address={walletAddress} />;

      default:
        return <OwnAssetProfile user={user} address={walletAddress} />;
    }
  };

  return (
    <div>
      <HeroProfile address={walletAddress} />
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-3 col-md-7 order-md-0 order-1">
            <SidebarProfile user={user} address={walletAddress} />
          </div>
          <div className="col-lg-9 col-md-12 order-md-1 order-0">
            <div className="profile__content">
              <div className="d-flex justify-content-between">
                <div className="nav-tabs">
                  <button
                    className={`btn btn-sm mr-2 ${
                      selectedTab === 0 ? "active btn-primary" : "btn-white"
                    }`}
                    onClick={() => setSelectedTab(0)}
                  >
                    Owned
                  </button>
                  <button
                    className={`btn btn-sm mr-2 ${
                      selectedTab === 1 ? "active btn-primary" : "btn-white"
                    }`}
                    onClick={() => setSelectedTab(1)}
                  >
                    Created
                  </button>
                  <button
                    className={`btn btn-sm mr-2 ${
                      selectedTab === 2 ? "active btn-primary" : "btn-white"
                    }`}
                    onClick={() => setSelectedTab(2)}
                  >
                    Collections
                  </button>
                </div>
              </div>

              {/* Conditionally render content based on the selected tab */}
              <div className="tab-content mt-3">{renderContent()}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OtherProfile;
